import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { useLang } from "../context/LanguageContext";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err?.response?.data?.detail) || "Failed to send reset email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="forgot-password-page" className="max-w-md mx-auto px-6 py-20">
      <div className="text-xs font-mono uppercase tracking-[0.3em] text-slate-500">
        {t("auth.forgotTitle")}
      </div>
      <h1 className="mt-2 font-display font-extrabold text-4xl tracking-tight">
        {t("auth.forgotTitle")}
      </h1>
      <p className="mt-3 text-sm text-slate-600">{t("auth.forgotBody")}</p>

      {sent ? (
        <div
          data-testid="forgot-password-sent"
          className="mt-8 border border-emerald-200 bg-emerald-50 text-emerald-900 p-4 text-sm"
        >
          {t("auth.forgotSent")}
        </div>
      ) : (
        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <label className="text-xs font-mono uppercase tracking-widest">
              {t("auth.email")}
            </label>
            <input
              data-testid="forgot-password-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full h-11 px-3 border border-black/15 focus:border-electric focus:outline-none"
            />
          </div>
          {error && (
            <div data-testid="forgot-password-error" className="text-sm font-mono text-destructive">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="forgot-password-submit"
            className="w-full h-12 bg-ink text-white hover:bg-electric disabled:opacity-50 transition-colors text-xs font-mono uppercase tracking-[0.2em]"
          >
            {loading ? t("auth.forgotSending") : t("auth.forgotBtn")}
          </button>
        </form>
      )}

      <div className="mt-6 text-sm">
        <Link to="/login" data-testid="forgot-password-back" className="text-electric underline">
          {t("auth.backToSignIn")}
        </Link>
      </div>
    </div>
  );
}
